// PawIcon.jsx
import React from 'react';

export default function PawIcon({
  size = 14, // ✅ default = current small size (px)
  className = '',
  nudgeX = 0,
  nudgeY = 0,
}) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      aria-hidden="true"
      className={className}
    >
      <g transform={`translate(${nudgeX} ${nudgeY})`}>
        {/* Toes */}
        <ellipse cx="7.6" cy="8.8" rx="2.2" ry="2.8" fill="currentColor" />
        <ellipse cx="12.0" cy="7.4" rx="2.0" ry="2.7" fill="currentColor" />
        <ellipse cx="16.4" cy="8.8" rx="2.2" ry="2.8" fill="currentColor" />

        {/* Pad */}
        <path
          fill="currentColor"
          d="
            M12 12.2
            C8.6 12.2 6.0 14.6 6.0 17.3
            C6.0 19.2 7.5 20.4 9.4 20.4
            C10.5 20.4 11.4 20.0 12.0 19.3
            C12.6 20.0 13.5 20.4 14.6 20.4
            C16.5 20.4 18.0 19.2 18.0 17.3
            C18.0 14.6 15.4 12.2 12.0 12.2
            Z
          "
        />
      </g>
    </svg>
  );
}
